export default "__VITE_ASSET__1d4ac453__"